<template>
  <div>
    <span v-for="(info, index) in gradeInfoList" :key="index" class="img-box">
      <img :src="require(`@/assets/images/common/element-icons-72-x-72-ic-rating-content-${info.title}.svg`)" :width="size" :height="size" alt="주제 아이콘">
      <em class="text">{{ info.grade }}</em>
    </span>
  </div>
</template>

<script>
export default {
  name: 'GradeInfo',
  props: {
    gradeInfo: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 50
    }
  },
  data () {
    return {
      gradeInfoList: []
    }
  },
  methods: {
    setGradeInfo () {
      const gradeInfo = this.sortGradeInfoPriority()

      this.gradeInfoList = Object.entries(gradeInfo).map(info => {
        const [ title, grade ] = info
        return { title: this.convertImageName(title), grade: this.gradeText(grade) }
      })
    },
    sortGradeInfoPriority () {
      const priorityList = ['subject', 'sex', 'violence', 'dialogue', 'horror', 'drug', 'imitation'] // grade info 노출 순서
      const newGradeInfo = {} // sorted grade info

      Object.keys(this.gradeInfo).map(category => `${priorityList.indexOf(category)}_${category}`).sort().map(key => {
        key = key.replace(/(\d+)_/gi, '')
        newGradeInfo[key] = this.gradeInfo[key]
      })
      return newGradeInfo
    },
    convertImageName (title) {
      switch (title) {
        case 'subject' : return 'theme'
        case 'sex' : return 'sexuality'
        case title: return title
      }
    },
    gradeText (grade) {
      switch (grade) {
        case '1': case '': return '낮음'
        case '2': return '보통'
        case '3': return '다소 높음'
        case '4': return '높음'
        case '5': return '매우 높음'
        case '11': return '전체'
        case '12': return '12세'
        case '13': return '15세'
        case '14': return '청불'
        case '15': return '제한'
      }
    }
  },
  created () {
    this.setGradeInfo()
  }
}
</script>
f
